import React from "react";
import { Row, Col, Tabs, Tab, Container } from "react-bootstrap";
import Inbox from "./Inbox";
import styles from "./BoxContainer.module.css"; // Optional custom styles
function BoxContainer({
    contextProvider,
    contextPatient,
    contextEncounter,
    fhirClient,
    communicationService,
    error,
    orgConfig }) {

    return (
        <Container fluid>
            <Row className="mt-1">
                <Col md={12}>
                    <div className="d-flex justify-content-between align-items-center py-1 px-1 border-bottom shadow-sm">
                        {/* Left: Logo + Title */}
                        <div className="d-flex align-items-center">
                            <div style={{ width: "50px", height: "40px", flexShrink: 0 }}>
                                <img
                                    src="/images/logos/iris-logo5.png"
                                    alt="IRIS Logo"
                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                            </div>
                            <h3 className={`mb-0 ms-0 ${styles.pageTitle}`}>IRIS Provider Communications</h3>
                        </div>

                        {/* Center: Org-specific logo and welcome message inline */}
                        {orgConfig && (
                            <div
                                style={{
                                    flex: 1,
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    fontSize: "1rem",
                                    color: "#333",
                                    gap: "0.5rem" // optional spacing between logo and text
                                }}
                            >
                                <span>{orgConfig.welcomeMessage}</span>
                                {orgConfig.logo && (
                                    <img
                                        src={orgConfig.logo}
                                        alt="Org Logo"
                                        style={{ maxHeight: "40px", objectFit: "contain" }}
                                    />
                                )}

                            </div>
                        )}

                        {/* Right: Company Logo */}
                        <div style={{ width: "120px", height: "40px", flexShrink: 0 }}>
                            <img
                                src="/images/endpoint-logo3.png"
                                alt="User Avatar"
                                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                            />
                        </div>
                    </div>

                    <Inbox
                        contextProvider={contextProvider}
                        contextPatient={contextPatient}
                        contextEncounter={contextEncounter}
                        fhirClient={fhirClient}
                        communicationService={communicationService}
                        error={error}
                    />
                </Col>
            </Row>
        </Container>
    );
}

export default BoxContainer;